export const servicesTranslations = {
  en: {
    title: 'Services',
    description: 'Manage services available for deals',
    addService: 'Add Service',
    editService: 'Edit Service',
    deleteService: 'Delete Service',
    serviceDetails: 'Service Details',
    // Articoli tab (products catalog reused as "Items", no warehouse addon required)
    servicesTab: 'Services',
    articlesTab: 'Items',
    newArticle: 'New Item',
    editArticle: 'Edit Item',
    articleName: 'Item Name',
    articleSku: 'SKU',
    articleSkuPlaceholder: 'Auto-generated if empty',
    articleShortDescription: 'Short Description',
    articlePrice: 'List Price',
    articleCostPrice: 'Cost Price',
    articleVat: 'VAT Rate',
    articleCategory: 'Category',
    articleNoCategory: 'No Category',
    articleImageUrl: 'Image URL',
    articleStock: 'Stock',
    manageStock: 'Manage Stock',
    lowStockThreshold: 'Low Stock Threshold',
    openInWarehouse: 'Open full record in Warehouse',
    deleteArticleConfirm: 'Are you sure you want to delete this item? This action cannot be undone.',
    articleSave: 'Save Item',
    articleSaved: 'Item saved successfully',
    articleDeleted: 'Item deleted successfully',
    articleSearchPlaceholder: 'Search items...',
    noArticlesFound: 'No items found. Start by adding one.',
    lowStock: 'Low Stock',
    articleStatusActive: 'Active',
    articleStatusDraft: 'Draft',
    articleStatusInactive: 'Inactive',
    articleColumnStatus: 'Status',
    articleCountSingular: 'item',
    articleCountPlural: 'items',
    deleteArticleTitle: 'Delete Item',
    deleteArticleConfirmButton: 'Delete',
    articleNameRequired: 'Name is required',
    articleListPriceRequired: 'List price is required',
    articleSaveError: 'Error saving the item',
    articleDeletePermissionError: 'You do not have permission to delete items',
    articleDeleteError: 'Error deleting the item',
    ai: {
      aiAssistant: 'AI Assistant',
      generateWithAI: 'Generate text with AI',
      generateMultiple: 'Generate All with AI',
      promptLabel: 'AI Prompt:',
      promptPlaceholder: 'What do you want the AI to do with this text?',
      promptRequired: 'Please enter a prompt to generate text',
      emptyResponseError: 'No text generated. Try again with a different prompt.',
      currentText: 'Current text:',
      serviceTitle: 'Service title:',
      noText: 'No text',
      promptExamples: 'Prompt examples:',
      promptExample1: 'Improve the existing text by better highlighting client benefits',
      promptExample2: 'Create a professional description with bold titles and bullet points for advantages',
      promptExample3: 'Rewrite the text more persuasively, organizing it into "What we offer", "Benefits" and "Why choose us"',
      promptExample4: 'Create a completely new description that emphasizes concrete results and benefits',
      // Short description prompt examples
      shortPromptExample1: 'Write a concise one-sentence description',
      shortPromptExample2: 'Create a brief marketing tagline',
      shortPromptExample3: 'Summarize the main benefit in 10-15 words',
      shortPromptExample4: 'Generate a short SEO-friendly description',
      // Terms & conditions prompt examples
      termsPromptExample1: 'Create standard terms and conditions for this service',
      termsPromptExample2: 'Generate legal disclaimer and payment terms',
      termsPromptExample3: 'Write service delivery terms and cancellation policy',
      termsPromptExample4: 'Outline customer responsibilities and service limitations',
      // Multiple generation modal
      generateAllTitle: 'Generate All Content with AI',
      generateAllDescription: 'Select which content to generate for this service:',
      shortDescriptionOption: 'Short Description',
      fullDescriptionOption: 'Full Description',
      termsOption: 'Terms & Conditions',
      selectAtLeastOne: 'Please select at least one content type',
      promptForAll: 'Prompt for all selected content:',
      promptForShort: 'Prompt for Short Description:',
      promptForFull: 'Prompt for Full Description:',
      promptForTerms: 'Prompt for Terms & Conditions:',
      generateSelected: 'Generate Selected',
      generatingMultiple: 'Generating content...',
      cancel: 'Cancel',
      generating: 'Generating...',
      generate: 'Generate text'
    },
    form: {
      title: 'Service Title',
      titlePlaceholder: 'Enter service title',
      shortDescription: 'Short Description',
      shortDescriptionPlaceholder: 'Brief description for deals and contracts',
      description: 'Description',
      descriptionPlaceholder: 'Write a detailed description of the service...',
      termsAndConditions: 'Terms and Conditions',
      termsAndConditionsPlaceholder: 'Write the terms and conditions for this service...',
      listPrice: 'List Price',
      serviceType: 'Service Type',
      oneTime: 'One-time',
      monthly: 'Monthly',
      annual: 'Annual',
      category: 'Category',
      noCategory: 'No Category',
      manageCategories: 'Manage Categories',
      variables: 'Service Variables',
      variablesSubtitle: 'Define customizable variables for this service that can be adjusted per deal',
      addVariable: 'Add Variable',
      noVariables: 'No variables defined. Add variables to make your service customizable.',
      variableName: 'Variable Name',
      variableNamePlaceholder: 'e.g., numUsers, storageLimit',
      defaultValue: 'Default Value',
      defaultValuePlaceholder: 'e.g., 5, 1GB',
      variableDescription: 'Description',
      variableDescriptionPlaceholder: 'e.g., Number of user licenses',
      update: 'Update Service',
      create: 'Create Service',
      cancel: 'Cancel',
      // Hours Package
      hoursPackage: 'Hours Package',
      hoursPackageDescription: 'Configure this service as an hours package for time tracking',
      isHoursPackage: 'Hours Package Service',
      isHoursPackageHint: 'Enable to configure this service as an hours package with time tracking',
      hoursPackageDefault: 'Default Hours',
      hoursPackageDefaultHint: 'Number of hours included in the package by default',
      hourlyRate: 'Hourly Rate',
      hourlyRateHint: 'Rate charged for hours exceeding the package',
      alertThreshold: 'Alert Threshold (%)',
      alertThresholdHint: 'Percentage of hours used that triggers an alert'
    },
    hoursPackageHelp: {
      title: 'Hours Package',
      description: 'Configure this service as a hours package to track time usage:',
      tip1: 'When added to a deal, the configuration is copied to the deal service',
      tip2: 'Tickets linked to this deal service will consume hours',
      tip3: 'You\'ll receive alerts when the threshold is reached',
      tip4: 'Useful for support contracts, consulting, or retainer agreements'
    }
  },
  it: {
    title: 'Servizi',
    description: 'Gestisci i servizi disponibili per le offerte',
    addService: 'Aggiungi Servizio',
    editService: 'Modifica Servizio',
    deleteService: 'Elimina Servizio',
    serviceDetails: 'Dettagli Servizio',
    // Tab Articoli (anagrafica products riusata come "Articoli", senza addon magazzino)
    servicesTab: 'Servizi',
    articlesTab: 'Articoli',
    newArticle: 'Nuovo Articolo',
    editArticle: 'Modifica Articolo',
    articleName: 'Nome Articolo',
    articleSku: 'SKU',
    articleSkuPlaceholder: 'Generato automaticamente se vuoto',
    articleShortDescription: 'Descrizione Breve',
    articlePrice: 'Prezzo di Listino',
    articleCostPrice: 'Prezzo di Costo',
    articleVat: 'Aliquota IVA',
    articleCategory: 'Categoria',
    articleNoCategory: 'Nessuna Categoria',
    articleImageUrl: 'URL Immagine',
    articleStock: 'Giacenza',
    manageStock: 'Gestisci Giacenza',
    lowStockThreshold: 'Soglia Scorta Minima',
    openInWarehouse: 'Apri scheda completa nel Magazzino',
    deleteArticleConfirm: 'Sei sicuro di voler eliminare questo articolo? Questa azione non può essere annullata.',
    articleSave: 'Salva Articolo',
    articleSaved: 'Articolo salvato con successo',
    articleDeleted: 'Articolo eliminato con successo',
    articleSearchPlaceholder: 'Cerca articoli...',
    noArticlesFound: 'Nessun articolo trovato. Inizia aggiungendone uno.',
    lowStock: 'Sotto scorta',
    articleStatusActive: 'Attivo',
    articleStatusDraft: 'Bozza',
    articleStatusInactive: 'Inattivo',
    articleColumnStatus: 'Stato',
    articleCountSingular: 'articolo',
    articleCountPlural: 'articoli',
    deleteArticleTitle: 'Elimina Articolo',
    deleteArticleConfirmButton: 'Elimina',
    articleNameRequired: 'Il nome è obbligatorio',
    articleListPriceRequired: 'Prezzo di listino obbligatorio',
    articleSaveError: 'Errore durante il salvataggio dell\'articolo',
    articleDeletePermissionError: 'Non hai i permessi per eliminare articoli',
    articleDeleteError: 'Errore durante l\'eliminazione dell\'articolo',
    ai: {
      aiAssistant: 'Assistente IA',
      generateWithAI: 'Genera testo con IA',
      generateMultiple: 'Genera tutto con IA',
      promptLabel: 'Prompt per l\'IA:',
      promptPlaceholder: 'Cosa vuoi che l\'IA faccia con questo testo?',
      promptRequired: 'Inserisci un prompt per generare il testo',
      emptyResponseError: 'Nessun testo generato. Riprova con un prompt diverso.',
      currentText: 'Testo attuale:',
      serviceTitle: 'Titolo del servizio:',
      noText: 'Nessun testo',
      promptExamples: 'Esempi di prompt:',
      promptExample1: 'Migliora il testo esistente evidenziando meglio i benefici per il cliente',
      promptExample2: 'Crea una descrizione professionale con titoli in grassetto e punti elenco per i vantaggi',
      promptExample3: 'Riformula il testo in modo più persuasivo, organizzandolo in "Cosa offriamo", "Vantaggi" e "Perché sceglierci"',
      promptExample4: 'Crea una descrizione completamente nuova che enfatizza risultati e benefici concreti',
      // Short description prompt examples
      shortPromptExample1: 'Scrivi una descrizione concisa in una frase',
      shortPromptExample2: 'Crea un breve slogan di marketing',
      shortPromptExample3: 'Riassumi il vantaggio principale in 10-15 parole',
      shortPromptExample4: 'Genera una breve descrizione ottimizzata per SEO',
      // Terms & conditions prompt examples
      termsPromptExample1: 'Crea termini e condizioni standard per questo servizio',
      termsPromptExample2: 'Genera disclaimer legale e termini di pagamento',
      termsPromptExample3: 'Scrivi termini di erogazione del servizio e politica di cancellazione',
      termsPromptExample4: 'Delinea responsabilità del cliente e limitazioni del servizio',
      // Multiple generation modal
      generateAllTitle: 'Genera tutti i contenuti con IA',
      generateAllDescription: 'Seleziona quali contenuti generare per questo servizio:',
      shortDescriptionOption: 'Descrizione Breve',
      fullDescriptionOption: 'Descrizione Completa',
      termsOption: 'Termini e Condizioni',
      selectAtLeastOne: 'Seleziona almeno un tipo di contenuto',
      promptForAll: 'Prompt per tutti i contenuti selezionati:',
      promptForShort: 'Prompt per Descrizione Breve:',
      promptForFull: 'Prompt per Descrizione Completa:',
      promptForTerms: 'Prompt per Termini e Condizioni:',
      generateSelected: 'Genera Selezionati',
      generatingMultiple: 'Generazione contenuti in corso...',
      cancel: 'Annulla',
      generating: 'Generazione in corso...',
      generate: 'Genera testo'
    },
    form: {
      title: 'Titolo Servizio',
      titlePlaceholder: 'Inserisci titolo servizio',
      shortDescription: 'Descrizione Breve',
      shortDescriptionPlaceholder: 'Breve descrizione per offerte e contratti',
      description: 'Descrizione',
      descriptionPlaceholder: 'Scrivi una descrizione dettagliata del servizio...',
      termsAndConditions: 'Termini e Condizioni',
      termsAndConditionsPlaceholder: 'Scrivi i termini e le condizioni per questo servizio...',
      listPrice: 'Prezzo di Listino',
      serviceType: 'Tipo di Servizio',
      oneTime: 'Una tantum',
      monthly: 'Mensile',
      annual: 'Annuale',
      category: 'Categoria',
      noCategory: 'Nessuna Categoria',
      manageCategories: 'Gestisci Categorie',
      variables: 'Variabili del Servizio',
      variablesSubtitle: 'Definisci variabili personalizzabili per questo servizio che possono essere regolate per offerta',
      addVariable: 'Aggiungi Variabile',
      noVariables: 'Nessuna variabile definita. Aggiungi variabili per rendere il tuo servizio personalizzabile.',
      variableName: 'Nome Variabile',
      variableNamePlaceholder: 'es., numUtenti, limiteDiArchiviazione',
      defaultValue: 'Valore Predefinito',
      defaultValuePlaceholder: 'es., 5, 1GB',
      variableDescription: 'Descrizione',
      variableDescriptionPlaceholder: 'es., Numero di licenze utente',
      update: 'Aggiorna Servizio',
      create: 'Crea Servizio',
      cancel: 'Annulla',
      // Hours Package
      hoursPackage: 'Monte Ore',
      hoursPackageDescription: 'Configura questo servizio come pacchetto monte ore per il tracciamento del tempo',
      isHoursPackage: 'Servizio Monte Ore',
      isHoursPackageHint: 'Abilita per configurare questo servizio come pacchetto monte ore con tracciamento tempo',
      hoursPackageDefault: 'Ore Predefinite',
      hoursPackageDefaultHint: 'Numero di ore incluse nel pacchetto di default',
      hourlyRate: 'Tariffa Oraria',
      hourlyRateHint: 'Tariffa per le ore che eccedono il pacchetto',
      alertThreshold: 'Soglia Alert (%)',
      alertThresholdHint: 'Percentuale di ore consumate che attiva un alert'
    },
    hoursPackageHelp: {
      title: 'Monte Ore',
      description: 'Configura questo servizio come monte ore per tracciare il consumo di tempo:',
      tip1: 'Quando viene aggiunto a un deal, la configurazione viene copiata nel deal service',
      tip2: 'I ticket collegati a questo deal service consumeranno ore',
      tip3: 'Riceverai alert quando la soglia viene raggiunta',
      tip4: 'Utile per contratti di assistenza, consulenza o accordi a forfait'
    }
  }
};